export const PROBLEM_ITEMS = [
  {
    question: '«Сколько тратить на рекламу, чтобы выйти на нужную выручку?»',
    answer:
      'Большинство малых бизнесов устанавливают рекламный бюджет на ощущениях, без понимания точки окупаемости.',
  },
  {
    question: '«Реклама идёт, заявки есть, а прибыль не растёт»',
    answer:
      'Потому что проблема часто не в рекламе, а в глубине чека, конверсии продаж или структуре расходов.',
  },
  {
    question: '«Что именно делать, чтобы вырасти, и с чего начать?»',
    answer:
      'Хаотичные действия без системы не дают роста. Нужен маршрут от точки А к точке Б — в конкретных цифрах.',
  },
];

export const FUNNEL_STEPS = [
  {
    num: '01',
    title: 'Диагностика — ваша точка А',
    description:
      'Вводите текущие показатели бизнеса. Сервис считает, где вы находитесь, и показывает главное узкое место: что тянет прибыль вниз прямо сейчас.',
    badge: 'Бесплатно',
    badgeClass: 'free',
    highlight: false,
  },
  {
    num: '02',
    title: 'Три сценария точки Б + интерпретация',
    description:
      'Математика рассчитывает три варианта достижения цели. ИИ-директор объясняет, что значит каждая цифра, и что конкретно делать именно в вашей ситуации.',
    badge: '25 000 ₸',
    badgeClass: 'paid',
    highlight: true,
  },
  {
    num: '03',
    title: 'Маркетинговый план на 6 месяцев',
    description:
      'Конкретные каналы продвижения, инструменты и метрики контроля — под ваши цифры и выбранный сценарий. Берёте и делаете.',
    badge: 'В составе плана',
    badgeClass: 'inc',
    highlight: false,
  },
];

export const PLAN_ITEMS = [
  { num: '①', title: 'Диагностика точки А', text: 'где бизнес сейчас и что мешает расти' },
  { num: '②', title: 'Три сценария роста', text: 'консервативный, базовый и оптимистичный с расчётом каждого рычага' },
  { num: '③', title: 'Интерпретация от ИИ-директора', text: 'что значат ваши цифры и что конкретно делать' },
  { num: '④', title: 'Маркетинговые каналы и инструменты', text: 'что запускать, в какой последовательности' },
  { num: '⑤', title: 'KPI и метрики контроля', text: 'как понять, что движетесь в нужном направлении' },
];

export const FOR_WHOM_CARDS = [
  {
    icon: '📊',
    title: 'Работаете с рекламой и не понимаете окупаемость',
    description:
      'Деньги уходят на таргет, заявки есть, но сколько реально зарабатываете с каждой? Диагностика покажет красную линию и реальный ROMI.',
  },
  {
    icon: '🎯',
    title: 'Хотите вырасти, но непонятно за какой рычаг тянуть',
    description:
      'Поднять чек? Больше лидов? Улучшить конверсию? Математика покажет что даст максимальный эффект именно в вашей ситуации.',
  },
  {
    icon: '🧭',
    title: 'Принимаете решения по маркетингу на ощущениях',
    description:
      '«Кажется, надо запустить рекламу» — это не система. Нужен маршрут от точки А к точке Б с конкретными цифрами и шагами.',
  },
];

export const NOT_FOR_CHIPS = [
  'Стартап без продаж',
  'Нет никаких цифр о бизнесе',
  'Ищете исполнителя «под ключ»',
  'Маркетинг = только SMM',
];

export const FEATURED_TOOLS = [
  {
    to: '/tools/cpl-calculator',
    category: 'Реклама',
    name: 'Калькулятор CPL',
    description: 'Допустимая стоимость заявки от вашей маржи',
  },
  {
    to: '/tools/budget-planner',
    category: 'Реклама',
    name: 'Планировщик бюджета',
    description: 'Сколько нужно на рекламу для достижения цели',
  },
  {
    to: '/tools/revenue-levers',
    category: 'Финансы',
    name: 'Рычаги роста выручки',
    description: 'Какой рычаг даёт максимум именно вам',
  },
  {
    to: '/tools/startup-calculator',
    category: 'Финансы',
    name: 'Калькулятор запуска',
    description: 'Сколько нужно продать для нужной прибыли',
  },
  {
    to: '/tools/profit-control',
    category: 'Финансы',
    name: '6 рычагов прибыли',
    description: 'Двигайте рычаги — смотрите как меняется прибыль',
  },
  {
    to: '/tools/brief-generator',
    category: 'Реклама',
    name: 'Генератор брифа',
    description: 'Готовый бриф для таргетолога за 5 минут',
  },
  {
    to: '/tools/audience-builder',
    category: 'Аудитория',
    name: 'Конструктор ЦА',
    description: 'AI строит JTBD-портрет по вашим данным',
  },
];

export const ABOUT_STATS = [
  { num: '12+', label: 'лет в маркетинге' },
  { num: '7', label: 'стран опыта' },
  { num: '4×', label: 'рост объёма при штате ×2' },
  { num: '9/10', label: 'оценка от коллег' },
];

export const DEFAULT_WIDGET = {
  revenue: 500000,
  ads: 50000,
  check: 8000,
};

export const calcWidgetMetrics = ({ revenue, ads, check }) => {
  const r = Number(revenue) || 0;
  const a = Number(ads) || 0;
  const c = Number(check) || 1;

  return {
    potential: r * 0.3,
    share: r > 0 ? `${((a / r) * 100).toFixed(1)}%` : '—',
    clients: c > 0 ? Math.round(r / c) : '—',
  };
};

export const formatWidgetMoney = (value) => `${Math.round(value).toLocaleString('ru-RU')} ₸`;
